import { BridgeFormJSState } from '../../Types';
import { getParamFromSchema } from '../ParamFromSchema';
import { AllParamModel } from '../ParamModelTypes';
import { GroupParamSchema } from '../ParamSchemaTypes';

export const getValueParamsFromSchema =
  (
    param: GroupParamSchema,
    inputId: string,
    model: AllParamModel | undefined
  ) =>
  (state: BridgeFormJSState) => {
    return param.valueParams.reduce(getParamFromSchema(inputId, model), state);
  };
